const getCareUnitsState = (state) => state && state.careUnit ? state.careUnit : {};
export const careUnitList = (state) => getCareUnitsState(state).careUnitList;
export const createDialogOpen = (state) => getCareUnitsState(state).createDialogOpen;
export const updateDialogOpen = (state) => getCareUnitsState(state).updateDialogOpen;
export const deleteDialogOpen = (state) => getCareUnitsState(state).deleteDialogOpen;
export const careUnitForm = (state) => getCareUnitsState(state).careUnitForm;
export const saveCareUnitError = (state) => getCareUnitsState(state).saveCareUnitError;
export const errorMessage = (state) => getCareUnitsState(state).errorMessage;
export const profileDialogOpen = (state) => getCareUnitsState(state).profileDialogOpen;
export const isLoading = (state) => getCareUnitsState(state).isLoading;